module.exports = __webpack_public_path__ + "img/2.a4ac40cd.png";